import React from "react";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <span>Developed by Vanessa Barsotti</span>
      <span>2023 &copy; All rights reserved</span>
    </footer>
  );
};

export default Footer;
